(function($) {
    var rememberanceCard = $('#navbarPaging');

    // wait a second before expanding navbar circle
    setTimeout(function() {
        rememberanceCard
            .addClass('is-visible')
    }, 1000);

    // wait a second before expanding navbar circle to full width
    setTimeout(function() {
        rememberanceCard
            .addClass('is-expanded')
    }, 2000);
}(jQuery));
